import { CreateFlowLogRequest, FlowLog, FlowLogsPaginated } from '../types/FlowLog';
import { IGetOneResponse } from '../util/Types/Generic';
import { ApiService } from './ApiService';

export class FlowLogsService extends ApiService {
  static pathName = '/flow-logs';

  static getFlowLogs = (
    flowId: string,
    page: number = 1,
    limit: number = 25,
  ): Promise<FlowLogsPaginated> => {
    return ApiService.get(
      `${this.pathName}?flowId=${flowId}&page=${page}&limit=${limit}`,
    );
  };

  static getFlowLog = (id: string): Promise<IGetOneResponse<FlowLog>> => {
    return ApiService.get(`${this.pathName}/${id}`);
  };

  static createLog = (data: CreateFlowLogRequest): Promise<IGetOneResponse<FlowLog>> => {
    return ApiService.post(this.pathName, data);
  };
}

